import { Dispatch, bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import CreateCompany from '../../components/CreateCompany';
import { createAccount } from './action';
import { setMessage } from '../../store/reducers/message';

const mapStateToProps = (state: any) => {
    const { loading, message } = state;
    return {
        loading,
        message,
    };
};

const mapDispatchToProps = (dispatch: Dispatch) => {
    return bindActionCreators({ onSubmit: createAccount, setMessage }, dispatch);
};

interface IDispatchToProps {
    onSubmit: (formData: any) => void;
}

const ConnectedCreateAdminRoles = connect<any, IDispatchToProps, void>(
    mapStateToProps,
    mapDispatchToProps
)(CreateCompany);

export default ConnectedCreateAdminRoles;
